import React from 'react';
import PressRelease from '../../PressRelease';
// eslint-disable-next-line import/no-cycle
import CTA from '../../CTA';
import HeaderText from '../../HeaderText';
import BodyText from '../../BodyText';
import ContentBreak from '../../contentBreak';

/** this is causing a hydration issue that leads to the form not always showing */
// const Typeform = React.lazy(() => import('../../typeform/TypeformWrapper'));
import Typeform from '../../typeform/TypeformWrapper';

/**
 * @param {import("@contentful/rich-text-types").Block | import("@contentful/rich-text-types").Inline} node
 * @param {FF.ContentfulBlockEmbeddedEntriesOptions=} options
 * */
export default function BlockEmbeddedEntries(node, options = {}) {
  switch (node.data.target?.__typename) {
    case 'ContentfulPressRelease':
      return <PressRelease data={node.data.target} />;
    case 'ContentfulPrimaryCta':
      return <CTA buttonType="primary" {...node.data.target} />;
    case 'ContentfulSecondaryCta':
      return <CTA buttonType="secondary" {...node.data.target} />;
    case 'ContentfulTertiaryCta':
      return <CTA buttonType="tertiary" {...node.data.target} />;
    case 'ContentfulTypeformForm':
      return <Typeform {...node.data.target} />;
    case 'ContentfulHeaderText':
      return <HeaderText {...node.data.target} {...options.HeaderText} />;
    case 'ContentfulBodyText':
      return <BodyText {...node.data.target} />;
    case 'ContentfulContentBreak':
      return <ContentBreak {...node.data.target} />;
    default:
      return null;
  }
}
